// @flow weak

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { defaultProps } from 'recompose';

import { DateTime } from '@zapier/date';

import TruncatedText from 'app/common/components/TruncatedText';
import 'app/common/components/MonthlyUsageResetDate.scss';

import type { HOC } from 'recompose';

import type { KindType } from 'app/common/types';

type MonthlyUsageResetDateProps = {
  endDate: string,
  label?: string,
  className?: string,
  kind?: KindType,
};

const MonthlyUsageResetDate = props => {
  const bem = bemify('monthly-usage-reset-date');
  return (
    <p className={bem(props.className, toModifiers(props.kind))}>
      <TruncatedText className={bem('__label')}>{props.label}</TruncatedText>
      <TruncatedText className={bem('__delta')}>
        <DateTime date={props.endDate} format="short" />
      </TruncatedText>
    </p>
  );
};

const defaultPropsValue = {
  label: 'Monthly Usage Reset',
};

const enhanceMonthlyUsageResetDate: HOC<
  *,
  MonthlyUsageResetDateProps
> = defaultProps(defaultPropsValue);

export default enhanceMonthlyUsageResetDate(MonthlyUsageResetDate);
